<template>
    <div class="permission-menu">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>权限菜单配置</span>
            </div>

            <!-- 搜索区域 -->
            <div class="search-area">
                <el-input v-model="searchKeyword" placeholder="请输入权限名称或菜单名称搜索" style="width: 300px; margin-right: 10px"
                    clearable @keyup.enter.native="handleSearch">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-select v-model="permissionFilter" placeholder="权限筛选" style="width: 150px; margin-right: 10px"
                    clearable filterable>
                    <el-option v-for="role in roleList" :key="role.id" :label="role.description"
                        :value="role.id"></el-option>
                </el-select>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>

                <!-- 配置权限菜单按钮 -->
                <el-button type="primary" @click="handleAddPermissionConfig" style="margin-left: auto">
                    配置权限菜单
                </el-button>
            </div>

            <!-- 权限菜单配置表格 -->
            <el-table :data="filteredPermissionConfigList" style="width: 100%; margin-top: 20px" v-loading="loading"
                border stripe :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                :cell-style="{ padding: '8px 0' }">
                <!-- 序号列 -->
                <el-table-column type="index" label="序号" width="80" align="center" header-align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="menuId" label="菜单ID" width="100" align="center" header-align="center">
                </el-table-column> -->


                <el-table-column prop="roleName" label="权限名称" min-width="150" align="center" header-align="center">
                </el-table-column>
                <el-table-column prop="status" label="权限ID" width="150" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getPermissionTagType(scope.row.status)" size="small">
                            {{ scope.row.status }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="menuName" label="菜单名称" min-width="180" align="center" header-align="center">
                    <template slot-scope="scope">
                        {{ scope.row.menuName || '未知菜单' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center" header-align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 空状态提示 -->
            <div v-if="filteredPermissionConfigList.length === 0 && !loading" class="empty-state">
                <el-empty description="暂无配置数据"></el-empty>
            </div>
        </el-card>

        <!-- 添加/编辑权限菜单配置对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
            <div class="dialog-description">
                <p>配置权限与菜单的对应关系：为指定权限分配可访问的菜单</p>
            </div>
            <el-form ref="permissionConfigForm" :model="permissionConfigForm" :rules="rules" label-width="100px">
                <el-form-item label="权限ID" prop="status">
                    <el-input v-model="permissionConfigForm.status" placeholder="权限ID" disabled></el-input>
                    <div style="font-size: 12px; color: #999; margin-top: 5px; line-height: 20px;">
                        提示：权限ID会根据选择的权限自动生成
                    </div>
                </el-form-item>
                <el-form-item label="权限" prop="roleName">
                    <el-select v-model="permissionConfigForm.roleName" placeholder="请选择权限" style="width: 100%"
                        filterable @change="handlePermissionChange">
                        <el-option v-for="role in roleList" :key="role.id" :label="role.description"
                            :value="role.description">
                            <span style="float: left">{{ role.description }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">
                                ID: {{ role.id }}
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="菜单ID" prop="menuId">
                    <el-input v-model="permissionConfigForm.menuId" placeholder="菜单ID" disabled></el-input>
                </el-form-item>
                <el-form-item label="菜单" prop="menuName">
                    <el-select v-model="permissionConfigForm.menuName" placeholder="请选择菜单" style="width: 100%"
                        filterable @change="handleMenuChange">
                        <el-option v-for="menu in menuOptions" :key="menu.id" :label="menu.name" :value="menu.name">
                            <span style="float: left">{{ menu.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">
                                ID: {{ menu.id }}
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>



            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitPermissionConfigForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'PermissionMenu',
    data() {
        return {
            // 权限菜单配置列表数据
            permissionConfigList: [],
            // 权限列表数据（从接口获取）
            roleList: [],
            // 菜单列表数据（从接口获取）
            menuList: [],
            // 搜索关键词
            searchKeyword: '',
            // 权限筛选
            permissionFilter: '',
            // 加载状态
            loading: false,
            // 菜单加载状态
            menuLoading: false,
            // 对话框显示状态
            dialogVisible: false,
            // 是否为编辑模式
            isEditMode: false,
            // 对话框标题
            dialogTitle: '配置权限菜单',
            // 权限配置表单数据
            permissionConfigForm: {
                menuId: '',
                menuName: '',
                roleName: '',
                status: ''
            },
            // 权限映射关系（动态生成）
            permissionMapping: {},
            // 反向权限映射关系（动态生成）
            reversePermissionMapping: {},
            // 权限描述映射关系
            permissionDescriptionMapping: {},
            // 菜单映射关系
            menuMap: {},
            // 表单验证规则
            rules: {
                roleName: [
                    { required: true, message: '请选择权限', trigger: 'change' }
                ],
                menuName: [
                    { required: true, message: '请选择菜单', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        // 过滤后的权限配置列表
        filteredPermissionConfigList() {
            let filtered = this.permissionConfigList

            // 关键词搜索
            if (this.searchKeyword.trim()) {
                const keyword = this.searchKeyword.toLowerCase()
                filtered = filtered.filter(item =>
                    (item.roleName && item.roleName.toLowerCase().includes(keyword)) ||
                    (item.menuName && item.menuName.toLowerCase().includes(keyword)) ||
                    (item.menuId && item.menuId.toString().includes(keyword)) ||
                    (item.status && item.status.toString().includes(keyword))
                )
            }

            // 权限筛选
            if (this.permissionFilter) {
                filtered = filtered.filter(item =>
                    item.status.toString() === this.permissionFilter.toString()
                )
            }

            return filtered
        },

        // 菜单选项（从接口获取的数据）
        menuOptions() {
            // 如果接口返回了菜单数据，使用接口数据
            if (this.menuList && this.menuList.length > 0) {
                return this.menuList
                    .map(menu => ({
                        id: menu.id,
                        name: menu.name || '未知菜单'
                    }))
                    .sort((a, b) => a.id - b.id) // 按ID升序排序
            }
            
            // 如果没有接口数据，使用默认数据（兼容性）
            return [
                { id: 28, name: '运营首页' },
                { id: 30, name: '未知菜单' },
                { id: 34, name: '运营审核' },
                { id: 35, name: '运营管理' },
                { id: 42, name: '合规管理' },
                { id: 44, name: '质量管理' },
                { id: 48, name: '管理员工具' },
                { id: 50, name: '权限管理' }
            ].sort((a, b) => a.id - b.id) // 默认数据也按ID排序
        }
    
    },
    created() {
        this.fetchPermissionConfigList()
        this.fetchRoleList()
        this.fetchMenuList()
    },
    methods: {
        // 初始化菜单映射关系
        initMenuMap() {
            this.menuMap = {}
            this.menuOptions.forEach(menu => {
                this.menuMap[menu.name] = menu.id
            })
        },

        // 初始化权限映射关系
        initPermissionMappings() {
            this.permissionMapping = {}
            this.reversePermissionMapping = {}
            this.permissionDescriptionMapping = {}

            this.roleList.forEach(role => {
                this.permissionMapping[role.description] = role.id
                this.reversePermissionMapping[role.id] = role.description
                this.permissionDescriptionMapping[role.id] = role.description
            })
        },

        // 获取权限描述
        getPermissionDescription(status) {
            return this.permissionDescriptionMapping[status] || '未知权限'
        },

        // 生成随机颜色
        getRandomColor() {
            const colors = [
                'magenta', 'red', 'volcano', 'orange', 'gold',
                'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'
            ]
            return colors[Math.floor(Math.random() * colors.length)]
        },

        // 获取权限标签类型
        getPermissionTagType(status) {
            const typeMap = {
                1001: 'success',  // 企业用户
                2001: 'warning',  // 审核人员
                3001: 'danger',   // 系统管理员
                4001: 'info'      // 测试修改
            }
            if (typeMap[status]) {
                return typeMap[status]
            }

            // 为其他值生成随机但稳定的颜色（基于status值）
            const randomColors = [
                'magenta', 'red', 'volcano', 'orange', 'gold',
                'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'
            ]

            // 使用status作为种子，确保相同status总是得到相同颜色
            const seed = parseInt(status) || 0
            const index = seed % randomColors.length
            return randomColors[index]
        },

        // API调用：获取权限列表
        async fetchRoleList() {
            try {
                const response = await this.$axios.get('/web/roleList/query')
                console.log('获取权限列表响应:', response.data)

                if (response.data.status === 200) {
                    this.roleList = response.data.object || []
                    this.initPermissionMappings()
                } else {
                    this.$message.error(response.data.msg || '获取权限列表失败')
                }
            } catch (error) {
                console.error('获取权限列表失败:', error)
                this.$message.error('获取权限列表失败')
            }
        },

        // API调用：获取菜单列表
        async fetchMenuList() {
            this.menuLoading = true
            try {
                const response = await this.$axios.get('/web/parentMenuList/query')
                console.log('获取菜单列表响应:', response.data)

                if (response.data.status === 200) {
                    this.menuList = response.data.object || []
                    console.log('菜单列表数据:', this.menuList)
                    this.initMenuMap()
                } else {
                    this.$message.error(response.data.msg || '获取菜单列表失败')
                }
            } catch (error) {
                console.error('获取菜单列表失败:', error)
                this.$message.error('获取菜单列表失败')
            } finally {
                this.menuLoading = false
            }
        },

        // API调用：获取权限菜单配置列表
        async fetchPermissionConfigList() {
            this.loading = true
            try {
                const response = await this.$axios.get('/web/roleMenuList/query')
                console.log('获取权限菜单配置响应:', response.data)

                if (response.data.status === 200) {
                    this.permissionConfigList = response.data.object || []
                } else {
                    this.$message.error(response.data.msg || '获取权限菜单配置失败')
                }
            } catch (error) {
                console.error('获取权限菜单配置失败:', error)
                this.$message.error('获取权限菜单配置失败')
            } finally {
                this.loading = false
            }
        },

        // API调用：添加权限菜单配置
        async addPermissionConfig(data) {
            console.log('添加权限菜单配置参数:', data);
            try {
                const response = await this.$axios.post('/web/roleMenu/add', data)
                console.log('添加权限菜单配置响应:', response.data)
                return response.data
            } catch (error) {
                console.error('添加权限菜单配置失败:', error)
                throw error
            }
        },

        // API调用：更新权限菜单配置
        async updatePermissionConfig(data) {
            try {
                const response = await this.$axios.post('/web/roleMenu/update', data)
                console.log('更新权限菜单配置响应:', response.data)
                return response.data
            } catch (error) {
                console.error('更新权限菜单配置失败:', error)
                throw error
            }
        },

        // API调用：删除权限菜单配置
        async deletePermissionConfig(roleId, menuId) {
            try {
                const response = await this.$axios.post('/web/roleMenu/delete', null, {
                    params: {
                        roleId: roleId,
                        menuId: menuId
                    }
                })
                console.log('删除权限菜单配置响应:', response.data)
                return response.data
            } catch (error) {
                console.error('删除权限菜单配置失败:', error)
                throw error
            }
        },

        // 搜索权限配置
        handleSearch() {
            // 使用computed属性自动过滤
        },

        // 重置搜索
        resetSearch() {
            this.searchKeyword = ''
            this.permissionFilter = ''
        },

        // 打开添加权限配置对话框
        handleAddPermissionConfig() {
            this.isEditMode = false
            this.dialogTitle = '配置权限菜单'
            this.dialogVisible = true
        },

        // 打开编辑权限配置对话框
        handleEdit(item) {
            this.isEditMode = true
            this.dialogTitle = '编辑权限菜单配置'
            this.permissionConfigForm = {
                menuId: item.menuId,
                menuName: item.menuName || '未知菜单',
                roleName: item.roleName,
                status: item.status
            }
            this.dialogVisible = true
        },

        // 权限名称变化时自动设置权限ID
        handlePermissionChange(permissionDescription) {
            if (this.permissionMapping[permissionDescription]) {
                this.permissionConfigForm.status = this.permissionMapping[permissionDescription]
            }
        },

        // 菜单名称变化时自动设置菜单ID
        handleMenuChange(menuName) {
            if (this.menuMap[menuName]) {
                this.permissionConfigForm.menuId = this.menuMap[menuName]
            } else {
                this.permissionConfigForm.menuId = ''
            }
        },

        // 删除权限配置
        handleDelete(item) {
            this.$confirm(`确定要删除 "${item.roleName}" 对 "${item.menuName || '菜单ID:' + item.menuId}" 的访问权限配置吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    // 使用正确的参数格式调用删除接口
                    const response = await this.deletePermissionConfig(item.status, item.menuId)
                    if (response.status === 200) {
                        this.$message.success('删除成功')
                        this.fetchPermissionConfigList()
                    } else {
                        this.$message.error(response.msg || '删除失败')
                    }
                } catch (error) {
                    console.error('删除权限配置失败:', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {
                // 用户取消删除
            })
        },

        // 提交权限配置表单
        submitPermissionConfigForm() {
            this.$refs.permissionConfigForm.validate(async (valid) => {
                if (valid) {
                    try {
                        if (this.isEditMode) {
                            // 编辑权限配置
                            const response = await this.updatePermissionConfig(this.permissionConfigForm)
                            if (response.status === 200) {
                                this.$message.success('更新成功')
                                this.dialogVisible = false
                                this.fetchPermissionConfigList()
                            } else {
                                this.$message.error(response.object || '更新失败')
                            }
                        } else {
                            // 添加权限配置
                            const response = await this.addPermissionConfig(this.permissionConfigForm)
                            if (response.status === 200) {
                                this.$message.success('配置成功')
                                this.dialogVisible = false
                                this.fetchPermissionConfigList()
                            } else {
                                this.$message.error(response.object || '配置失败')
                            }
                        }
                    } catch (error) {
                        console.error('操作失败:', error)
                        this.$message.error('操作失败')
                    }
                }
            })
        },

        // 对话框关闭处理
        handleDialogClose() {
            this.$refs.permissionConfigForm.resetFields()
            this.permissionConfigForm = {
                menuId: '',
                menuName: '',
                roleName: '',
                status: ''
            }
        }
    }
}
</script>

<style scoped>
.permission-menu {
    padding: 20px;
}

.box-card {
    min-height: calc(100vh - 100px);
}

.search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-table {
    margin-top: 20px;
    font-size: 14px;
}

.el-table::before {
    height: 0;
}

.el-button+.el-button {
    margin-left: 5px;
}

.el-tag {
    margin: 0;
}

.empty-state {
    margin: 40px 0;
    text-align: center;
}

.dialog-description {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
    color: #606266;
}

.dialog-description p {
    margin: 0;
}

/* 表格行悬停效果 */
.el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #f5f7fa;
}

/* 表头样式优化 */
.el-table th {
    font-weight: 600;
    background-color: #f5f7fa !important;
}

/* 单元格内边距优化 */
.el-table td,
.el-table th {
    padding: 12px 0;
}

/* 操作按钮容器 */
.el-table .cell {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>